<div class="container-fluid p-0 about-fasinating-diamond-main-section">
    <div class="mobile_version-backbutton">
        <a class="mobile-header" onclick="history.back()">
            <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Refund Policy</a>
    </div>
    <div class="secure-shopping about-fasinating-diamond">

        <div class="container">
            <div class="section-title-wrap section-header flex-header text-center" style="justify-content: center;">
                <div class="section-title-text text-center pt-4">
                    <h1 class="title">Refund Policy</h1>
                </div>
            </div>
            <div [innerHTML]="cmsContentData" class="section-contain"></div>
        </div>
    </div>
</div>

<!-- <section class="find-partner-page">
    <div class="mobile_version-backbutton">
      <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Refund Policy</a>
    </div>
    <div class="container">
        <div class="row">            
            <div class="col-md-12 mobile_border_top">
                <div class="right-side-section col-md-12">
                    <div class="right-top-bar">
                        <div class="col-md-12">
                            <div class="section-title-wrap section-header flex-header text-center"
                                style="justify-content: center;">
                                <div class="section-title-text text-center">
                                    <h1 class="title">Refund Policy</h1>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 terms-form privacy-policy">
                            <ol>
                                <h3 class="sub-title">1. Academy Affiliation</h3>
                                    <ul class="list-alpha">
                                        <li>
                                                <span>
                                                <strong>a. No refunds:</strong> Once an academy affiliates with
                                                the TPL App, the affiliation fee is considered non-refundable,
                                                and no refunds will be provided once the affiliation is
                                                established. The affiliation fee is a one-time payment that is
                                                non-reversible, regardless of whether the academy decides to end
                                                the affiliation mid-way due to any reason. It is important for
                                                academies to carefully consider their decision before proceeding
                                                with the affiliation process.
                                            </span> </li>
                                    </ul>
                                

                                <h3 class="sub-title">2. Tournaments</h3>
                                    <ul class="list-alpha">
                                        <li> 
                                            <span>
                                                <strong>a. Cancellation by the organizer:</strong> If the
                                                tournament is canceled by the organizer for any reason, a full
                                                refund of the registration fee will be provided. The amount will
                                                be refunded to the TPL Wallet within 5-7 working days.<br>
                                                However, once the tournament starts and the tournament is
                                                canceled mid-way by the organizer for any reason, no refund will
                                                be provided.

                                            </span> </li>
                                        <li> 
                                                <span>
                                                <strong>b. Participant withdrawal:</strong> If a participant
                                                decides to withdraw from the tournament before a certain
                                                deadline specified by the organizer, they will be eligible for a
                                                full refund. The amount will be refunded to the TPL Wallet
                                                within 5-7 working days.
                                                In case the participant withdraws after the deadline has passed,
                                                no refund will be provided


                                            </span> </li>
                                        <li>  <span>
                                                <strong>c. No-show or disqualification: </strong> In some cases, if
                                                a participant fails to show up for the tournament or is
                                                disqualified due to violating the rules, they may not be
                                                eligible for any refund.

                                            </span> </li>
                                    </ul>
                              

                                <h3 class="sub-title">3. Find a Partner</h3>
                                    <ul class="list-alpha">
                                        <li style="flex-wrap: nowrap;">
                                            <p style="margin-bottom: 0px;">
                                                <span>
                                                    <strong>a. Find a Pro: </strong> </span></p>
                                            <ul>
                                                <li>
                                                    <span>
                                                        <strong>i. If the Pro player rejects the
                                                            request/cancels/does not show up for a scheduled
                                                            session: </strong> 
                                                        The booking fee will be refunded to your TPL Wallet
                                                        within 5-7 working days.

                                                    </span>
                                                </li>
                                                <li>
                                                    <span>
                                                        <strong>ii. If the player who books the pro cancels/does not
                                                            show up for a scheduled session: </strong> No refund
                                                        will be provided.

                                                    </span>
                                                </li>
                                            </ul>
                                        </li>
                                        <li style="flex-wrap: nowrap;">
                                            <p style="margin-bottom: 0px;">
                                                    <span>
                                                    <strong>b. Find a Coach: </strong> </span></p>
                                            <ul>
                                                <li>
                                                    <span>
                                                        <strong>i. If the coach rejects the
                                                            request/cancels/does not show up for a scheduled
                                                            session: </strong> The booking fee will be refunded
                                                        to your TPL Wallet within 5-7 working days.

                                                    </span>
                                                </li>
                                                <li>
                                                    <span>
                                                        <strong>ii. If the player who books the coach cancels/does
                                                            not show up for a scheduled session: </strong> No
                                                        refund will be provided.

                                                    </span>
                                                </li>
                                            </ul>
                                        </li>
                                        <li style="flex-wrap: nowrap;">
                                            <p style="margin-bottom: 0px;"> <span>
                                                    <strong>c. Find a Player: </strong> </span></p>
                                            <ul>
                                                <li>
                                                    <span>
                                                        <strong>i. If the player who accepts the request cancels/does not show up for a scheduled session:
                                                        </strong> The player who had sent the request will be refunded the booking fee to his/her TPL Wallet within 5-7 working days.

                                                    </span>
                                                </li>
                                                <li>
                                                <span>
                                                        <strong>ii. If the player who sends the request cancels/does
                                                            not show up for a scheduled session: </strong>
                                                        No refund will be provided.

                                                    </span>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                               
                                <h3 class="sub-title">4. Contests</h3>
                                    <ul class="list-alpha">
                                        <li>
                                            <span>
                                                <strong>a. Joining a Contest: </strong>Once a
                                                participant joins a contest, it is important to note that
                                                participation is considered final and non-refundable. Once
                                                committed to the contest, there is no provision for exiting or
                                                withdrawing from the contest, and no refunds will be provided
                                                for any reason. Participants should carefully consider their
                                                decision to join a contest, as there will be no opportunity for
                                                refunds or changes once the contest has been entered. </span>

                                        </li>
                                        <li>
                                            <span>
                                                <strong>b. Contest Cancelation: </strong> In the event that the
                                                minimum number of entries required for a
                                                contest is not met or the match gets canceled before the player
                                                steps on the court, the contest will be canceled. Any coins or
                                                cash you invested in the contest will be promptly refunded to
                                                your TPL Wallet as we value your participation and want to
                                                ensure your satisfaction.</span>


                                        </li>




                                    </ul>
                            </ol>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</section> -->